import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';

import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';
import { ProductsListComponent } from 'ish-shared/components/product/products-list/products-list.component';

@Component({
  selector: 'ish-cms-product-list-manual',
  templateUrl: './cms-product-list-manual.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ProductsListComponent],
})
export class CMSProductListManualComponent implements CMSComponent, OnChanges {
  readonly pagelet = input.required<ContentPageletView>();

  productSKUs: string[] = [];

  ngOnChanges() {
    const pagelet = this.pagelet();
    this.productSKUs = pagelet.hasParam('Products')
      ? pagelet.configParam<string[]>('Products').map(product => product.split('@')[0])
      : [];
  }
}
